
<div class="overflow-hidden bg-[var(--light-grey)]">
  <footer class="relative border border-t-[var(--light-beige)]" style="background-color: var(--beige);">
    <div class="mx-auto container-padding max-w-screen-desktop">
  
      <div class="pt-12 pb-4">
        <div class="flex mobile-m:flex-row flex-col justify-start items-center gap-8 relative">
          <div class="flex flex-col gap-6 tablet:max-w-[460px] max-w-auto">
            <div class="flex mobile-m:flex-row mobile-m: justify-between items-center flex-col gap-10">
              <a routerLink="home" class="flex items-center">
                <img src="assets/logo.webp" alt="drinkhopping" style="width: auto; height: 100px; max-width: 200px;">
              </a>
              <div class="flex space-x-4 mb-4 md:mb-0">
                <a href="https://www.instagram.com/drink.hopping" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  class="text-[var(--black)] hover:text-[var(--secondary)]" 
                  aria-label="Instagram">
                  <fa-icon style="color: var(--dark-orange);" [icon]="faInstagram" size="2xl"></fa-icon>
                </a>
                <a href="https://www.tiktok.com/@drink.hopping" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  class="text-[var(--black)] hover:text-[var(--secondary)]" 
                  aria-label="TikTok">
                  <fa-icon style="color: var(--dark-orange);" [icon]="faTiktok" size="2xl"></fa-icon>
                </a>
                <a href="https://www.facebook.com/drink.hopping" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  class="text-[var(--black)] hover:text-[var(--secondary)]" 
                  aria-label="Facebook">
                  <fa-icon style="color: var(--dark-orange);" [icon]="faFacebook" size="2xl"></fa-icon>
                </a>
              </div>
            </div>
  
            <p class="text-[var(--black)]" style="text-align: justify;">
              {{ 'footer.description' | translate }}
            </p>

            <!-- Language selector footer -->
            <app-language-selector [openUp]="true"></app-language-selector>
          </div>
  
          <div class="w-full">
            <h4 class="mb-2 font-bold text-[23px]/[34px]">{{ 'footer.others' | translate }}</h4>
            <ul>
              <li><a routerLink="/help" class="text-[var(--black)] cursor-pointer hover:text-[var(--secondary)]">{{ 'footer.help' | translate }}</a></li>
              <li><a routerLink="/companies" class="text-[var(--black)] cursor-pointer hover:text-[var(--secondary)]">{{ 'footer.companies' | translate }}</a></li>
              <li><a routerLink="/policies/refund" class="text-[var(--black)] cursor-pointer hover:text-[var(--secondary)]">{{ 'footer.refundPolicy' | translate }}</a></li>
              <li><a routerLink="/policies/privacy" href="/policies/privacy" class="text-[var(--black)] cursor-pointer hover:text-[var(--secondary)]">{{ 'footer.privacyPolicy' | translate }}</a></li>
              <li><a routerLink="/policies/terms" class="text-[var(--black)] cursor-pointer hover:text-[var(--secondary)]">{{ 'footer.terms' | translate }}</a></li>
            </ul>
          </div>
  
          <div class="w-full">
            <h4 class="mb-2 font-bold text-[23px]/[34px]">{{ 'footer.contact' | translate }}</h4>
            <p class="text-[var(--black)]">
              Email: <a href="mailto:soporte&#64;drinkhopping.com" class="hover:underline">soporte&#64;drinkhopping.com</a>
            </p>
            <p class="text-[var(--black)]">
              Instagram: <a href="https://www.instagram.com/drink.hopping" target="_blank" class="hover:underline">drink.hopping</a>
            </p>
            <p class="text-[var(--black)]">
              Facebook: <a href="https://www.facebook.com/drink.hopping" target="_blank" class="hover:underline">drink.hopping</a>
            </p>
            <p class="text-[var(--black)]">
              TikTok: <a href="https://www.tiktok.com/@drink.hopping" target="_blank" class="hover:underline">drink.hopping</a>
            </p>
          </div>
  

                  
          <div class="hidden desktop:block relative" style="width: clamp(350px, 44vw, 490px); height: 1px;">
            <div class="hidden desktop:block absolute top-0 left-[100%] transform -translate-x-[40%] -translate-y-[40%]">
              <img src="assets/mascota.webp" alt="Drinkhopping hoppinsito" class="max-w-[fit-content] " style="height: clamp(350px, 44vw, 490px); max-height: clamp(350px, 44vw, 490px);">
            </div>
          </div>
        </div>
  
        <div class="flex gap-6 justify-center items-center py-4">
          <img src="assets/3dsecure-logos/visa.webp" alt="Visa" class="mobile-m:h-12 h-8" />
          <img src="assets/3dsecure-logos/mastercard.webp" alt="Mastercard" class="mobile-m:h-12 h-8" />
          <img src="assets/3dsecure-logos/american-express.webp" alt="American Express" class="mobile-m:h-12 h-8" />
        </div>
      </div>
  
    </div>
  

  </footer>
  

</div>
<div class="bg-[var(--black)]">
    
  <div class="mx-auto container-padding max-w-screen-desktop">
    <p class="py-4 text-left text-[var(--white)]" style="font-size: 15px; font-weight: 400; line-height: 22px;">
      {{ 'footer.rights' | translate: { year: currentYear } }}
    </p>
  </div>

</div>